import {
  ajax
} from 'application/src/js/functions.js';

/**
 * @class
 * @param {number} args.rawmaterialid
 * @param {object} args.translations
 * @param {Mediator} args.mediator
 */
export default class VolumeMap {
  constructor(args) {
    this.rawmaterialid = args.rawmaterialid;
    this.translations = args.translations;
    this.mediator = args.mediator;

    this.container = document.querySelector('.lp-content .cropdata');
    this.outerMap = this.container.querySelector('.volume-map');

    this.requestUrl = `/app/ajax/ajaxLoadProductionVolumes`;
    this.user = null;
    this.debugMode = true;
    this.hideClass = 'hide';
    this.showTopNews = false;

    this.year = (new Date()).getFullYear() - 2;

    this.chartOptions = {
      colorAxis: {
        colors: [
          'rgb(212, 237, 222)',
          'rgb(27, 121, 66)'
        ]
      },
      backgroundColor: {
        fill: '#c4eafc',
        // stroke: '#0071bc',
        strokeWidth: 0
      },
      datalessRegionColor: '#fff',
      legend: 'none',
      defaultColor: '#fff'
    }

    this.load()
      .then(response => {
        this.user = response.user;

        this.volumeData = [
          [this.translations.country, this.translations.productionVolume]
        ];

        response.data.map(countryData => {
          this.volumeData.push([
            countryData.country_code,
            parseFloat(countryData.production)
          ])
        });

        google.charts.setOnLoadCallback(_ => {
          if (this.volumeData.length) this.container.classList.remove(this.hideClass);
          this.createMapChart();
          this.drawChart();
          this.addEvents();
          this.mediator.publish('finishedLoading');
        });
      })
      .catch(e => {
        if (this.debugMode && e) console.log(e);
        this.mediator.publish('finishedLoading');
      });
  }

  addEvents() {
    window.addEventListener('resize', _ => {
      this.wait().then(_ => this.drawChart());
    });
  }

  wait() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    return new Promise((resolve, reject) => {
      this.searchTimeout = setTimeout(_ => resolve(), 250);
    });
  }

  load() {
    this.mediator.publish('startedLoading');

    return ajax(this.requestUrl, {
      rawmaterialid: this.rawmaterialid,
      year: this.year,
    });
  }

  createMapChart() {
    this.chartData = google.visualization.arrayToDataTable(this.volumeData);
    this.chart = new google.visualization.GeoChart(this.outerMap);
  }

  drawChart() {
    this.chart.draw(this.chartData, this.chartOptions);
  }
}